import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";
import { db } from "../../firebase";

const NotificationSettings = () => {
  const { currentUser } = useAuth();
  const [emailNotifs, setEmailNotifs] = useState(true);
  const [pushNotifs, setPushNotifs] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchNotificationPrefs = async () => {
      if (!currentUser) return;
      const ref = doc(db, "preferences", currentUser.uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setEmailNotifs(data.emailNotifs ?? true);
        setPushNotifs(data.pushNotifs ?? false);
      }
    };
    fetchNotificationPrefs();
  }, [currentUser]);

  const handleSave = async () => {
    if (!currentUser) return;
    try {
      const ref = doc(db, "preferences", currentUser.uid);
      await setDoc(
        ref,
        { emailNotifs, pushNotifs },
        { merge: true }
      );
      setMessage("✅ Notification settings updated.");
    } catch (err) {
      console.error("Error saving notification settings:", err);
      setMessage("❌ Failed to save settings.");
    }
  };

  return (
    <div className="space-y-4 text-sm">
      <h2 className="text-lg font-semibold mb-4">Notification Settings</h2>

      <div className="bg-gray-50 p-4 rounded-lg shadow-sm flex justify-between items-center">
        <div>
          <h3 className="font-medium">Email Notifications</h3>
          <p className="text-gray-600">Receive updates via email.</p>
        </div>
        <input
          type="checkbox"
          checked={emailNotifs}
          onChange={() => setEmailNotifs(!emailNotifs)}
          className="form-checkbox h-5 w-5"
        />
      </div>

      <div className="bg-gray-50 p-4 rounded-lg shadow-sm flex justify-between items-center">
        <div>
          <h3 className="font-medium">Push Notifications</h3>
          <p className="text-gray-600">Receive updates via browser push.</p>
        </div>
        <input
          type="checkbox"
          checked={pushNotifs}
          onChange={() => setPushNotifs(!pushNotifs)}
          className="form-checkbox h-5 w-5"
        />
      </div>

      <button
        onClick={handleSave}
        className="mt-2 px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Save Preferences
      </button>

      {message && (
        <p className={`text-xs mt-2 ${message.startsWith("✅") ? "text-green-600" : "text-red-600"}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default NotificationSettings;
